module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-menu"
  }, [_c('div', {
    staticClass: "c-menu__btn",
    class: {
      'c-menu__btn--open': _vm.menuOpen
    },
    on: {
      "click": function($event) {
        _vm.toggleMenu()
      }
    }
  }, [_c('span', {
    staticClass: "c-menu__btn-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "c-menu__btn-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "c-menu__btn-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "c-menu__btn-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-menu__btn-text"
  }, [_c('p', {
    staticClass: "c-menu__btn-inner"
  }, [_vm._v("MENU")]), _vm._v(" "), (_vm.menuOpen) ? _c('p', {
    staticClass: "c-menu__btn-inner c-menu__btn-inner--open"
  }, [_vm._v("CLOSE")]) : _vm._e(), _vm._v(" "), (!_vm.menuOpen) ? _c('p', {
    staticClass: "c-menu__btn-inner c-menu__btn-inner--open"
  }, [_vm._v("OPEN")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "c-menu__offcanvas",
    class: {
      'c-menu__offcanvas--open': _vm.menuCanOpen
    },
    attrs: {
      "id": "offcanvas-perspective"
    }
  }, [_c('span', {
    staticClass: "c-menu__circle",
    attrs: {
      "id": "perspective-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-menu__mask",
    attrs: {
      "id": "menu-mask"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-menu__items js-panel"
  }, [_c('ul', {
    staticClass: "c-menu__link-list"
  }, [_c('li', {
    staticClass: "c-menu__link-listItem",
    class: {
      'c-menu__link-listItem--active': _vm.activeRoute == 'home'
    }
  }, [_c('a', {
    staticClass: "c-menu__menu-item",
    attrs: {
      "href": ""
    },
    on: {
      "mouseover": function($event) {
        _vm.animateMenuItem('H', false, 'I')
      }
    }
  }, [_c('span', {
    staticClass: "c-menu__counter"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "c-menu__menu-itemInner",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("HOME")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "c-menu__link-listItem",
    class: {
      'c-menu__link-listItem--active': _vm.activeRoute == 'shop'
    }
  }, [_c('a', {
    staticClass: "c-menu__menu-item",
    attrs: {
      "href": ""
    },
    on: {
      "mouseover": function($event) {
        _vm.animateMenuItem('S', false, 'II')
      }
    }
  }, [_c('span', {
    staticClass: "c-menu__counter"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "c-menu__menu-itemInner",
    attrs: {
      "to": "/shop"
    }
  }, [_vm._v("SHOP")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "c-menu__link-listItem",
    class: {
      'c-menu__link-listItem--active': _vm.activeRoute == 'about'
    }
  }, [_c('a', {
    staticClass: "c-menu__menu-item",
    attrs: {
      "href": ""
    },
    on: {
      "mouseover": function($event) {
        _vm.animateMenuItem('A', false, 'III')
      }
    }
  }, [_c('span', {
    staticClass: "c-menu__counter"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "c-menu__menu-itemInner",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("ABOUT")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "c-menu__sub-items"
  }, [_c('li', {
    staticClass: "c-menu__link-listItem c-menu__link-listItem--minor",
    class: {
      'c-menu__link-listItem--active': _vm.activeRoute == 'contact'
    }
  }, [_c('a', {
    staticClass: "c-menu__menu-item",
    attrs: {
      "href": ""
    },
    on: {
      "mouseover": function($event) {
        _vm.animateMenuItem('C', false, 'IV')
      }
    }
  }, [_c('span', {
    staticClass: "c-menu__counter"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "c-menu__menu-itemInner",
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("CONTACT")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "c-menu__link-listItem c-menu__link-listItem--minor",
    class: {
      'c-menu__link-listItem--active': _vm.activeRoute == 'terms and conditions'
    }
  }, [_c('a', {
    staticClass: "c-menu__menu-item",
    attrs: {
      "href": ""
    },
    on: {
      "mouseover": function($event) {
        _vm.animateMenuItem('T', false, 'V')
      }
    }
  }, [_c('span', {
    staticClass: "c-menu__counter"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "c-menu__menu-itemInner",
    attrs: {
      "to": "/termsandconditions"
    }
  }, [_vm._v("T&C's")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "c-menu__link-listItem c-menu__link-listItem--minor",
    class: {
      'c-menu__link-listItem--active': _vm.activeRoute == 'shipping and returns'
    }
  }, [_c('a', {
    staticClass: "c-menu__menu-item",
    attrs: {
      "href": ""
    },
    on: {
      "mouseover": function($event) {
        _vm.animateMenuItem('S', false, 'VII')
      }
    }
  }, [_c('span', {
    staticClass: "c-menu__counter"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "c-menu__menu-itemInner",
    attrs: {
      "to": "/shippingandreturns"
    }
  }, [_vm._v("SHIPPING")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "c-menu__link-listItem c-menu__link-listItem--minor",
    class: {
      'c-menu__link-listItem--active': _vm.activeRoute == 'shipping and returns'
    }
  }, [_c('a', {
    staticClass: "c-menu__menu-item",
    attrs: {
      "href": ""
    },
    on: {
      "mouseover": function($event) {
        _vm.animateMenuItem('R', false, 'VI')
      }
    }
  }, [_c('span', {
    staticClass: "c-menu__counter"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "c-menu__menu-itemInner",
    attrs: {
      "to": "/shippingandreturns"
    }
  }, [_vm._v("RETURNS")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "c-menu__link-listItem c-menu__link-listItem--minor",
    class: {
      'c-menu__link-listItem--active': _vm.activeRoute == 'privacy policy'
    }
  }, [_c('a', {
    staticClass: "c-menu__menu-item",
    attrs: {
      "href": ""
    },
    on: {
      "mouseover": function($event) {
        _vm.animateMenuItem('P', false, 'VIII')
      }
    }
  }, [_c('span', {
    staticClass: "c-menu__counter"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "c-menu__menu-itemInner",
    attrs: {
      "to": "/privacypolicy"
    }
  }, [_vm._v("PRIVACY POLICY")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-menu__images js-panel"
  }, [_c('ul', {
    staticClass: "c-menu__image-list"
  }, [_c('li', {
    staticClass: "c-menu__image-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/product/ring-thomas"
    }
  }, [_c('div', {
    staticClass: "js-hover-effect",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "data-displacement": "../assets/img/displacement/4.png",
      "data-intensity": "-0.65",
      "data-speed-in": "1.2",
      "data-speed-out": "1.2"
    },
    on: {
      "mouseover": function($event) {
        _vm.animateMenuItem('T', true, 'Thomas')
      }
    }
  }, [_c('img', {
    staticClass: "js-menu-img",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "loading": "lazy",
      "src": "/assets/img/Celtic-2.webp",
      "alt": "Signet ring - Thomas"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "js-menu-img",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "loading": "lazy",
      "src": "/assets/img/Celtic-grey-2.webp",
      "alt": "Signet ring - Thomas"
    }
  })])])], 1), _vm._v(" "), _c('li', {
    staticClass: "c-menu__image-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/product/ring-trixy"
    }
  }, [_c('div', {
    staticClass: "js-hover-effect",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "data-displacement": "../assets/img/displacement/5.png",
      "data-intensity": "-0.65",
      "data-speed-in": "1.2",
      "data-speed-out": "1.6"
    },
    on: {
      "mouseover": function($event) {
        _vm.animateMenuItem('T', true, 'Trixy')
      }
    }
  }, [_c('img', {
    staticClass: "js-menu-img",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "loading": "lazy",
      "src": "/assets/img/Celtic-2.webp",
      "alt": "Signet ring - Trixy"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "js-menu-img",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "loading": "lazy",
      "src": "/assets/img/Celtic-grey-2.webp",
      "alt": "Signet ring - Trixy"
    }
  })])])], 1), _vm._v(" "), _c('li', {
    staticClass: "c-menu__image-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/product/ring-lupus"
    }
  }, [_c('div', {
    staticClass: "js-hover-effect",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "data-displacement": "../assets/img/displacement/4.png",
      "data-intensity": "-0.65",
      "data-speed-in": "1.2",
      "data-speed-out": "1.2"
    },
    on: {
      "mouseover": function($event) {
        _vm.animateMenuItem('L', true, 'Lupus')
      }
    }
  }, [_c('img', {
    staticClass: "js-menu-img",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "loading": "lazy",
      "src": "/assets/img/Celtic-2.webp",
      "alt": "Signet ring - Lupus"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "js-menu-img",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "loading": "lazy",
      "src": "/assets/img/Celtic-grey-2.webp",
      "alt": "Signet ring - Lupus"
    }
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "c-menu__decoration js-panel"
  }, [_c('span', {
    staticClass: "c-menu__letter",
    attrs: {
      "id": "letter"
    }
  }, [_vm._v(_vm._s(_vm.currentLetter))]), _vm._v(" "), _c('div', {
    staticClass: "c-menu__pagination"
  }, [_c('span', {
    staticClass: "c-menu__pagenumber"
  }, [_c('h1', {
    staticClass: "c-menu__page c-menu__page--current"
  }, [_vm._v(_vm._s(_vm.symbol))]), _vm._v(" "), _c('span', {
    staticClass: "c-menu__divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('h1', {
    staticClass: "c-menu__page c-menu__page--hover"
  }, [_vm._v("IV")])]), _vm._v(" "), _c('span', {
    staticClass: "c-menu__ringname"
  }, [_c('h1', {
    staticClass: "c-menu__ringname-text"
  }, [_vm._v(_vm._s(_vm.symbol))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06ec0e62","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OffcanvasMenu.vue
// module id = 387
// module chunks = 0